/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'componentTrees',
		'componentTrees'
	],

	config: {
		checkParentComponentID: true
	},

	methods: {
		/**
		 * trigger onDecision
		 *
		 * @param data      {} - onTreeAction trigger context
		 */
		onTreeAction: function (data) {
			var self = this;

			switch (data.onTreeActionOptions.eventType) {
				case 'ready.jstree':
					this.deselectActiveNode();
					break;

				case 'select_node.jstree':
					if(!data.onTreeActionOptions.autoSelect || (this.config.decisionOptions && this.config.decisionOptions.decideOnAutoSelect)) {
						if(!(data.onTreeActionOptions.nodeData || {}).isGroup){
							this.parentComponents(undefined, function (parentComponent) {
								if (utils.isFunction(parentComponent.hooks.onDecision)) {
									parentComponent.trigger('onDecision', {
										decisionComponent: self,
										decisionType: 'submit',
										decisionOptions: utils.simpleMerge(self.config.decisionOptions || {}, { wasMassInsert: utils.keyboard.keysActive('strg') }),
										data: data.onTreeActionOptions.nodeData
									});

									// deselect active node for mass insert speedup
									self.deselectActiveNode();
									return false;
								}
							});
						}
					}
					break;
			}
		},

		onAttachDone: undefined
	},

	// NOTE: prevent componentTrees handlers from being called for this selectComponentTrees-Component
	handlers: undefined
};
